"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Dialog_1 = __importDefault(require("@mui/material/Dialog"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const globalVariables_1 = require("../../../common/globalVariables");
const modalEnums_1 = __importDefault(require("../../../common/modalEnums"));
const useEventListener_1 = __importDefault(require("../../../common/helpers/Hooks/useEventListener"));
const ActivityDetailsModal_1 = __importDefault(require("./ClasicModals/ActivityDetailsModal"));
const DirectoryAndOfferDetailsModal_1 = __importDefault(require("./ClasicModals/DirectoryAndOfferDetailsModal"));
const BookingDetailsModal_1 = __importDefault(require("./ClasicModals/BookingDetailsModal"));
const ContactModal_1 = __importDefault(require("./ClasicModals/ContactModal"));
const ConventionModal_1 = __importDefault(require("./ClasicModals/ConventionModal"));
const ChatIntroModal_1 = __importDefault(require("./ClasicModals/ChatIntroModal"));
const NotificationInstructionsModal_1 = __importDefault(require("./ClasicModals/NotificationInstructionsModal"));
const TUIChatModal_1 = __importDefault(require("./ClasicModals/TUIChatModal"));
const useAppUid_1 = require("../../behaviours/useAppUid");
const ModalGeneralWrapper = styled_components_1.default.div ``;
const ModalContent = styled_components_1.default.div `
  height: ${(props) => props.expandedHeight}px;
  width: ${(props) => props.expandedWidth}px;
  background-color: #fff;
`;
const ModalGeneral = ({ location, history }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [modalState, setModalState] = (0, react_1.useState)({});
    const [itemsInCart, setItemsInCart] = (0, react_1.useState)(false);
    const [showDiscardShoppingCartDialog, setShowDiscardShoppingCartDialog] = (0, react_1.useState)(false);
    const [orderCompleted, setOrderCompleted] = (0, react_1.useState)(false);
    const [renderTrigger, setRenderTrigger] = (0, react_1.useState)(false);
    const windowWidth = (0, react_1.useRef)(window.innerWidth);
    (0, useAppUid_1.useAppUid)();
    const onClose = (blockRedirect = false) => {
        var _a;
        if (orderCompleted) {
            setShowDiscardShoppingCartDialog(false);
            setIsOpen(false);
            setOrderCompleted(false);
            return;
        }
        if (itemsInCart && !orderCompleted) {
            setShowDiscardShoppingCartDialog(true);
        }
        else {
            setIsOpen(false);
        }
        if (!blockRedirect && modalState.modalProps.redirectOnClose) {
            if ((_a = history.location) === null || _a === void 0 ? void 0 : _a.key) {
                history.goBack();
            }
            history.replace(modalState.modalProps.redirectOnClose);
        }
    };
    const handleResize = () => {
        setRenderTrigger(!renderTrigger);
        if (modalState.modalProps.disableCloseOnResize) {
            return;
        }
        if (windowWidth.current !== window.innerWidth) {
            windowWidth.current = window.innerWidth;
            onClose(true);
        }
    };
    (0, react_1.useEffect)(() => {
        const openModal = (event) => {
            setModalState(event.detail);
            setIsOpen(true);
        };
        window.addEventListener("openModal", openModal);
        return () => {
            window.removeEventListener("openModal", openModal);
        };
    }, []);
    (0, useEventListener_1.default)("resize", () => {
        if (isOpen) {
            handleResize();
        }
    });
    (0, react_1.useEffect)(() => {
        onClose(true);
    }, [location]);
    const isDesktopModal = window.innerWidth > parseInt(globalVariables_1.WEB_APP.SHOW_CONTENT_AS_MODAL_BP);
    const modalSize = {
        height: isDesktopModal ? globalVariables_1.WEB_APP.MODAL_HEIGHT : window.innerHeight,
        width: isDesktopModal ? globalVariables_1.WEB_APP.MODAL_WIDTH : window.innerWidth,
    };
    const { modalType, modalProps } = modalState || {};
    return (react_1.default.createElement(ModalGeneralWrapper, null,
        react_1.default.createElement(Dialog_1.default, { open: isOpen, onClose: () => {
                if (modalProps.disableCloseOnClickOutsideModal) {
                    return;
                }
                onClose();
            }, fullScreen: !isDesktopModal, PaperProps: {
                style: {
                    borderRadius: !isDesktopModal ? 0 : 15,
                    maxWidth: isDesktopModal
                        ? `${globalVariables_1.WEB_APP.MODAL_WIDTH}px`
                        : "none",
                },
            } },
            react_1.default.createElement(ModalContent, { expandedWidth: modalSize.width, expandedHeight: modalSize.height }, renderModal(modalType, modalProps, onClose, setItemsInCart, setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog, setIsOpen, itemsInCart, orderCompleted, setOrderCompleted)))));
};
function renderModal(type, props, onClose, setItemsInCart, setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog, setIsOpen, itemsInCart, orderCompleted, setOrderCompleted) {
    switch (type) {
        case modalEnums_1.default.ACTIVITY_DETAILS:
            return (react_1.default.createElement(ActivityDetailsModal_1.default, Object.assign({}, props, { onClose: onClose, itemsInCart: itemsInCart, setItemsInCart: setItemsInCart, setShowDiscardShoppingCartDialog: setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog: showDiscardShoppingCartDialog, setIsOpen: setIsOpen, orderCompleted: orderCompleted, setOrderCompleted: setOrderCompleted })));
        case modalEnums_1.default.DIRECTORY_AND_OFFER_DETAILS:
            return (react_1.default.createElement(DirectoryAndOfferDetailsModal_1.default, Object.assign({}, props, { onClose: onClose, itemsInCart: itemsInCart, setItemsInCart: setItemsInCart, setShowDiscardShoppingCartDialog: setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog: showDiscardShoppingCartDialog, setIsOpen: setIsOpen, orderCompleted: orderCompleted, setOrderCompleted: setOrderCompleted })));
        case modalEnums_1.default.BOOKING_DETAILS:
            return react_1.default.createElement(BookingDetailsModal_1.default, Object.assign({}, props, { onClose: onClose }));
        case modalEnums_1.default.CONTACT:
            return react_1.default.createElement(ContactModal_1.default, { onClose: onClose });
        case modalEnums_1.default.CONVENTION:
            return react_1.default.createElement(ConventionModal_1.default, Object.assign({}, props, { onClose: onClose }));
        case modalEnums_1.default.CHAT_INTRO:
            return react_1.default.createElement(ChatIntroModal_1.default, Object.assign({}, props, { onClose: onClose }));
        case modalEnums_1.default.TUI_CHAT_MODAL:
            return react_1.default.createElement(TUIChatModal_1.default, Object.assign({}, props, { onClose: onClose }));
        case modalEnums_1.default.NOTIFICATION_INSTRUCTIONS:
            return react_1.default.createElement(NotificationInstructionsModal_1.default, Object.assign({}, props, { onClose: onClose }));
        default:
            return false;
    }
}
exports.default = (0, react_router_dom_1.withRouter)(ModalGeneral);
